module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.4b5a84aa.woff2";